module.exports = __webpack_public_path__ + "assets/img/gif_img6.b1819283.png";